// Utils
import CommonLayout from "../../_utils/CommonLayout";

// Components

// Components
import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const FieldForceRequestTxnConfirm = (props) => {
  return (
    <div className="max-w-tab-width-normal Qsmd:pt-padding-lg pt-padding-md px-padding-md Qlg:px-padding-base">
      <CommonLayout>
        <div className="lg:max-w-[var(--create-box-width)] w-width-full">
          <SourceDestinationAccountDetail
            type="destination"
            flow="beneficiary"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />
        </div>

        <div className="lg:max-w-[var(--create-box-width)] w-width-full">
          <Amount
            isPreview={true}
            txnPayLoad={{
              ...props?.txnPayLoad,
              amountInWords: props?.txnPayLoad?.amountWords,
            }}
          />
        </div>

        <CategorySelector
          previewMode={true}
          selectedCategory={props?.txnPayLoad?.selectedCategory}
          category={props?.txnPayLoad?.mergeCategory || []}
          IFSC={props?.txnPayLoad?.bankAccountIFSC}
          accountNumber={props?.txnPayLoad?.bankAccountNo}
          beneAccountId={props?.txnPayLoad?.beneAccountId}
          unassignCategories={[]}
          unassignlength={[]}
        />

        <div className="lg:max-w-[var(--create-box-width)] w-width-full">
          <AdditionalDetailsPreviewMapper
            mappingData={props.txnPayLoad.mergeCategory}
            previewImages={props?.previewImages}
          />
        </div>
      </CommonLayout>

      <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
    </div>
  );
};

export default FieldForceRequestTxnConfirm;
